// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"cf2ec5be","241":"21c93bee","333":"338b68d6","394":"baf27d35","853":"ddb9cba6","866":"25cdc5d0","992":"24eafbd6"}[chunkId] + ".chunk.css";
};